import axios from 'axios';
import { env } from 'env';
import { defaultRegion } from 'utils/common';
let apiInstance = null;
let socketInstance = null;
let apiExportIns = null;
let currentRegion = defaultRegion;

/**
 * Function to update the current region used in API headers
 * @param {string} region - Region code to use in API requests
 */
const setApiRegion = region => {
  currentRegion = region;
};
const apiInit = () => {
  axios.defaults.baseURL = env.REACT_APP_JARVIS_API_URL;
  if (apiInstance) {
    return apiInstance;
  }
  apiInstance = axios.create({
    timeout: 40000,
    headers: {
      Accept: 'application/json',
      'Access-Control-Allow-Origin': `${env.REACT_APP_JARVIS_API_URL}`
    }
  });
  // Add request interceptor to include region in headers
  apiInstance.interceptors.request.use(config => middlewareApiRequest(config));

  return apiInstance;
};

const initAuthorized = token => {
  apiInstance = axios.create({
    timeout: 40000,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Access-Control-Allow-Origin': `${env.REACT_APP_JARVIS_API_URL}`
    }
  });

  apiExportIns = axios.create({
    timeout: 40000,
    responseType: 'blob',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Access-Control-Allow-Origin': `${env.REACT_APP_JARVIS_API_URL}`
    }
  });

  apiInstance.interceptors.response.use(response => response, interceptor);
  apiInstance.interceptors.request.use(config => middlewareApiRequest(config));
  apiExportIns.interceptors.request.use(config => middlewareApiRequest(config));
};
const getApiInstance = () => apiInstance;

const getExportInstance = () => apiExportIns;

const socketInit = (initial = true) => {
  const reactSocketUrl = env.REACT_APP_JARVIS_IO_URL;

  if (!initial) {
    socketInstance?.close();
    return null;
  }

  if (socketInstance) {
    return socketInstance;
  }
  const { io } = require('socket.io-client');
  socketInstance = io(reactSocketUrl, {
    autoConnect: true,
    reconnection: true,
    reconnectionDelay: 500,
    transports: ['websocket'],
    protocols: ['http'],
    port: 1342,
    auth: { token: localStorage.getItem('access_token') }
  });
  return socketInstance;
};
const getSocketInstance = () => socketInstance;

const interceptor = data => {
  if (data?.response?.status === 401) {
    localStorage.removeItem('access_token');
    window.location = '/login';
  }
  if (data?.response?.status === 403) {
    window.location = '/forbidden';
  }
  return Promise.reject(data);
};

const middlewareApiRequest = config => {
  // Add the region header to every request
  config.headers = {
    ...config.headers,
    'jarvis-region': currentRegion
  };
  return config;
};

export {
  apiInit,
  getApiInstance,
  initAuthorized,
  getExportInstance,
  socketInit,
  getSocketInstance,
  setApiRegion
};
